export default "__VITE_ASSET__DSVXqEqf__"